"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPointsPayoutEndpoint = void 0;
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
exports.createPointsPayoutEndpoint = {
    [endpointIds_1.CREATE_POINTS_PAYOUT]: {
        payloadSchema: {
            type: 'object',
            properties: {
                userId: { type: 'string' },
                payoutCurrency: { type: 'string' },
            },
            required: ['userId'],
            additionalProperties: false,
        },
    },
};
